import React from 'react';
import './style.scss';
import AccordionDescription from './shared/description';
import Accordion from '../Accordion';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const AccordionComponent = (props) => {
  if (!props?.fields) {
    return <GenericPlaceholder componentName="Accordion" />;
  }
  const { heading, text, link, items } = props?.fields;

  return (
    <div className={clsx('content', 'accordion-component', 'add-margins', props.params?.Styles)}>
      <AccordionDescription title={heading} text={text} link={link} />
      <Accordion items={items} />
    </div>
  );
};

export default AccordionComponent;
